import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'
import './FullScreenPopup.css'

const useStyles = makeStyles((theme) => ({
    appBar: {
        position: 'relative',
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
}))

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />
})

const FullScreenPopup = ({
    open,
    handleClose,
    children,
    modaltitle,
    labelInfo,
    onClickInfoFunction,
}) => {
    const classes = useStyles()

    return (
        <div>
            <Dialog
                fullScreen
                className="fullScreenPopup"
                open={open}
                onClose={handleClose}
                TransitionComponent={Transition}
            >
                <AppBar className={classes.appBar}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.title}>
                            {modaltitle}
                            {labelInfo ? (
                                <span
                                    className="material-icons pointer info-label"
                                    onClick={() => {
                                        onClickInfoFunction(true)
                                    }}
                                >
                                    info
                                </span>
                            ) : null}
                        </Typography>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                </AppBar>
                <div className="modalChildren">{children}</div>
            </Dialog>
        </div>
    )
}

export default FullScreenPopup
